import { add, update, del, get, clear } from "./db";

export default class Config {
    static KEYS = {
        WORKER_VERSION: "worker_version",
        SUBSCRIBE_POPUP_SHOWN: "subscribe_popup_shown",
        USER_CHOICE: "user_choice",
        FCM_TOKEN: "fcm_token",
        APNS_TOKEN: "apns_token",
        PACKAGE_NAME: "package_name",
        APP_ID: "app_id",
        DEVICE_ID: "device_id",
        DEVICE_REGISTRATION_STATUS: "device_registration_status"
    };

    static async clear() {
        return clear("config");
    }

    static async add(key, value) {
        return add("config", key, { value });
    }

    static async update(key, value) {
        return update("config", key, { value });
    }

    static async del(key) {
        return del("config", key);
    }

    static async get(key) {
        return get("config", key);
    }
}
